import jquery from 'jquery';
window.$ = window.jQuery=jquery;
(function ($) {
  $.fn.menumaker = function (options) {
    var cssmenu = $(this),
      settings = $.extend(
        {
          format: "dropdown",
          sticky: false,
        },
        options
      );
    return this.each(function () {
      $(this)
        .find(".button")
        .on("click", function () {
          $(this).toggleClass("menu-opened");
          var mainmenu = $(this).next("ul");
          if (mainmenu.hasClass("open")) {
            mainmenu.slideToggle(300).removeClass("open");
          } else {
            mainmenu.slideToggle(300).addClass("open");
            if (settings.format === "dropdown") {
              mainmenu.find("ul").show();
            }
          }
        });
      cssmenu.find("li ul").parent().addClass("has-sub");
     const multiTg = function () {
        cssmenu
          .find(".has-sub")
          .prepend('<span class="submenu-button"></span>');
        cssmenu.find(".submenu-button").on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          
          var $this = $(this);
          var $submenu = $this.siblings("ul");
          
          // Close other submenus at the same level
          $this.parent().siblings().find(".submenu-button.submenu-opened").each(function() {
            $(this).removeClass("submenu-opened");
            $(this).siblings("ul").removeClass("open").slideUp(300);
          });
          
          $this.toggleClass("submenu-opened");
          
          if ($submenu.hasClass("open")) {
            $submenu.removeClass("open").slideUp(300, function() {
              // Force Safari to recalculate layout
              $(this).css('display', '');
            });
          } else {
            $submenu.addClass("open").slideDown(300, function() {
              // Ensure proper rendering in Safari
              $(this).css('display', 'block');
            });
          }
        });
      };
      if (settings.format === "multitoggle") multiTg();
      else cssmenu.addClass("dropdown");
      if (settings.sticky === true) cssmenu.css("position", "fixed");
      const resizeFix = function () {
        var mediasize = 1000;
        if ($(window).width() > mediasize) {
          cssmenu.find("ul").show();
          cssmenu.find(".submenu-button").removeClass("submenu-opened");
        }
        if ($(window).width() <= mediasize) {
          cssmenu.find("ul").hide().removeClass("open");
          cssmenu.find(".button").removeClass("menu-opened");
        }
      };
      resizeFix();
      return $(window).on("resize", resizeFix);
    });
  };
})(window.jQuery);

(function ($) {
  $(document).ready(function () {
    $("#cssmenu").menumaker({
      format: "multitoggle",
    });
  });
})(window.jQuery);
